// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const charizard_mega_y: PokeData = {
  "id": 10035,
  "name": "charizard-mega-y",
  "height": 17,
  "weight": 1005,
  "base_experience": 285,
  "types": [
    PokeType.FIRE,
    PokeType.FLYING
  ],
  "api_moves": [
    "scratch",
    "wing-attack",
    "growl",
    "ember",
    "flamethrower",
    "counter",
    "dragon-rage",
    "fire-spin",
    "smokescreen",
    "fury-swipes",
    "slash",
    "scary-face",
    "crunch",
    "heat-wave",
    "dragon-claw",
    "flare-blitz",
    "air-slash",
    "shadow-claw",
    "fire-fang",
    "flame-burst",
    "inferno"
  ],
  "moves": [
    "scratch",
    "growl",
    "ember",
    "flamethrower",
    "fire-spin",
    "scary-face",
    "crunch",
    "dragon-claw",
    "flare-blitz",
    "air-slash",
    "fire-fang",
    "roost",
    "tailwind"
  ],
  "evolution_chain": {
    "id": 2,
    "item": null,
    "species": [
      {
        "name": "charmander",
        "order": 4,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "charmeleon",
        "order": 5,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 4,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "charizard",
        "order": 6,
        "types": [
          PokeType.FIRE,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 5,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 101,
    "speed": 116,
    "ability_power": 184
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
